export const AddFeatureIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4401 2.56006H2.56006V17.4401H17.4401V2.56006Z"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M8.54028 5.53003H5.55029V8.52003H8.54028V5.53003Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M14.4602 5.53003H11.4702V8.52003H14.4602V5.53003Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M8.54028 11.48H5.55029V14.47H8.54028V11.48Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M14.4602 11.48H11.4702V14.47H14.4602V11.48Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const ArrowIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M13 15L8 10L13 5" stroke={fill || "#BDBDBD"} />
  </svg>
);

export const BackIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z"
      stroke="#107C41"
      strokeMiterlimit="10"
    />
    <path d="M15.4098 10H4.77979" stroke="#107C41" strokeMiterlimit="10" />
    <path
      d="M9.34984 5.73999L4.58984 9.99999L9.34984 14.26"
      stroke="#107C41"
      strokeMiterlimit="10"
    />
  </svg>
);

export const BellIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.57422 16.7109H6.86718L7.1028 17.3776C7.53969 18.6136 8.71849 19.5004 10.1057 19.5004C11.4929 19.5004 12.6717 18.6136 13.1086 17.3776L13.3442 16.7109H12.6372H7.57422Z"
      fill="#0063B1"
      stroke="white"
    />
    <mask
      id="path-2-outside-1_469_6116"
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="18"
      height="17"
      fill="black">
      <rect fill="white" x="1" y="1" width="18" height="17" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1055 2C11.0938 2 11.8949 2.80117 11.8949 3.78947V4.04989C14.4763 4.82154 16.3546 7.21977 16.3428 10.0526C16.341 10.4682 16.339 11.0661 16.337 11.6746C16.3319 13.263 16.6289 14.838 17.2114 16.3158H3C3.58249 14.838 3.87904 13.2631 3.8739 11.6746L3.86864 10.0526C3.85684 7.21994 5.73486 4.82182 8.316 4.05003V3.78947C8.316 2.80117 9.11717 2 10.1055 2Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1055 2C11.0938 2 11.8949 2.80117 11.8949 3.78947V4.04989C14.4763 4.82154 16.3546 7.21977 16.3428 10.0526C16.341 10.4682 16.339 11.0661 16.337 11.6746C16.3319 13.263 16.6289 14.838 17.2114 16.3158H3C3.58249 14.838 3.87904 13.2631 3.8739 11.6746L3.86864 10.0526C3.85684 7.21994 5.73486 4.82182 8.316 4.05003V3.78947C8.316 2.80117 9.11717 2 10.1055 2Z"
      fill="#0063B1"
    />
    <path
      d="M11.8949 4.04989H10.8949V4.79468L11.6085 5.008L11.8949 4.04989ZM16.3428 10.0526L15.3428 10.0485V10.0485L16.3428 10.0526ZM16.337 11.6746L17.337 11.6778V11.6778L16.337 11.6746ZM17.2114 16.3158V17.3158H18.6805L18.1417 15.9491L17.2114 16.3158ZM3 16.3158L2.06966 15.9491L1.53095 17.3158H3V16.3158ZM3.8739 11.6746L4.87389 11.6714L3.8739 11.6746ZM3.86864 10.0526L4.86864 10.0494L4.86863 10.0485L3.86864 10.0526ZM8.316 4.05003L8.60248 5.00811L9.316 4.79476V4.05003H8.316ZM12.8949 3.78947C12.8949 2.24889 11.6461 1 10.1055 1V3C10.5415 3 10.8949 3.35346 10.8949 3.78947H12.8949ZM12.8949 4.04989V3.78947H10.8949V4.04989H12.8949ZM11.6085 5.008C13.7768 5.65614 15.3527 7.67129 15.3428 10.0485L17.3428 10.0568C17.3565 6.76825 15.1759 3.98693 12.1813 3.09178L11.6085 5.008ZM15.3428 10.0485C15.341 10.4645 15.339 11.0629 15.337 11.6713L17.337 11.6778C17.339 11.0694 17.341 10.4718 17.3428 10.0568L15.3428 10.0485ZM15.337 11.6713C15.3315 13.3866 15.6522 15.0871 16.2811 16.6825L18.1417 15.9491C17.6056 14.5889 17.3323 13.1395 17.337 11.6778L15.337 11.6713ZM17.2114 15.3158H3V17.3158H17.2114V15.3158ZM3.93034 16.6825C4.55926 15.0869 4.87945 13.3864 4.87389 11.6714L2.8739 11.6779C2.87864 13.1397 2.60573 14.5891 2.06966 15.9491L3.93034 16.6825ZM4.87389 11.6714L4.86864 10.0494L2.86865 10.0559L2.8739 11.6779L4.87389 11.6714ZM4.86863 10.0485C4.85873 7.67144 6.43446 5.65638 8.60248 5.00811L8.02951 3.09194C5.03527 3.98726 2.85495 6.76844 2.86865 10.0568L4.86863 10.0485ZM7.316 3.78947V4.05003H9.316V3.78947H7.316ZM10.1055 1C8.56488 1 7.316 2.24889 7.316 3.78947H9.316C9.316 3.35346 9.66946 3 10.1055 3V1Z"
      fill="white"
      mask="url(#path-2-outside-1_469_6116)"
    />
  </svg>
);

export const ChatIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 12.8701H9.01L5.53 16.1301L5.51 12.8701H3.5V3.87012H16.5V12.8701Z"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const CreateRoomIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 15H18" stroke="#3A3A38" strokeMiterlimit="10" />
    <path d="M15 18V12" stroke="#3A3A38" strokeMiterlimit="10" />
    <path
      d="M11 17.25H3.5V8.25L10 2.75L16.5 8.25V11"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const CrossIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5L15 15" stroke={fill || "#242424"} />
    <path d="M15 5L5 15" stroke={fill || "#242424"} />
  </svg>
);

export const DocsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 7.48V17.5H4.5V2.5H10.52L15.5 7.48Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path d="M15.5 7.5H10.5V2.5" stroke="#3A3A38" strokeMiterlimit="10" />
  </svg>
);

export const ExportIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_83_634)">
      <path d="M14 17H4V3H14" stroke="#3A3A38" strokeMiterlimit="10" />
      <path d="M16.5 10H7.5" stroke="#3A3A38" strokeMiterlimit="10" />
      <path d="M13 6.5L17 10L13 13.5" stroke="#3A3A38" strokeMiterlimit="10" />
    </g>
    <defs>
      <clipPath id="clip0_83_634">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FolderOpenIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 15H3V5H9V6H15V15Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M14.98 15.25L17.75 8.75H6.03L3.25 15.25"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 9.25V17.25H11.5V11.25H8.5V17.25H3.5V9.25L10 2.75L16.5 9.25Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M2 10.75L10 2.75L18 10.75"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const IconPerson = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_92_1355)">
      <path
        d="M10 10.75C11.6569 10.75 13 9.40685 13 7.75C13 6.09315 11.6569 4.75 10 4.75C8.34315 4.75 7 6.09315 7 7.75C7 9.40685 8.34315 10.75 10 10.75Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M5.5 15.25C5.5 12.76 7.51 10.75 10 10.75C12.49 10.75 14.5 12.76 14.5 15.25"
        stroke="white"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_92_1355">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MaximumIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_413_7988)">
      <path
        d="M11.2667 17H17V3H3C3 3 3 5.99966 3 8.73333"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M3.15948 16.8894L9.52344 10.5254"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M7.99609 17L2.99609 17L2.99609 12"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_7988">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MenuDotIcon = ({ fill }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.5" cy="1.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="7.5" cy="1.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="13.5" cy="1.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="13.5" cy="7.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="7.5" cy="7.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="1.5" cy="7.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="1.5" cy="13.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="7.5" cy="13.5" r="1.5" fill={fill || "#242424"} />
    <circle cx="13.5" cy="13.5" r="1.5" fill={fill || "#242424"} />
  </svg>
);

export const MenuIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="6" width="12" height="1" fill={fill || "#3A3A38"} />
    <rect x="4" y="10" width="12" height="1" fill={fill || "#3A3A38"} />
    <rect x="4" y="14" width="12" height="1" fill={fill || "#3A3A38"} />
  </svg>
);

export const MinimumIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_413_7736)">
      <path
        d="M11.2706 17H17.0039V3H3.00391C3.00391 3 3.00391 5.99966 3.00391 8.73333"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M9.33662 10.6106L2.97266 16.9746"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M4.5 10.5L9.5 10.5L9.5 15.5"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_7736">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MinusIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="10" width="11" height="1" fill={fill || "#3A3A38"} />
  </svg>
);

export const ModeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="15" height="15" stroke="#3A3A38" />
    <path
      d="M9.74805 7.39404H6.63818V10.1763H9.51709V10.9766H6.63818V14.5H5.77344V6.59375H9.74805V7.39404ZM14.0503 14.5H13.1963V7.67334C13.0316 7.83805 12.763 8.01709 12.3906 8.21045C12.0182 8.40023 11.6781 8.53271 11.3701 8.60791V7.69482C11.764 7.58382 12.1865 7.40299 12.6377 7.15234C13.0889 6.90169 13.4451 6.6582 13.7065 6.42188H14.0503V14.5Z"
      fill="#3A3A38"
    />
  </svg>
);

export const OpacityIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="15" height="15" stroke="#3A3A38" />
    <path
      d="M9.74805 7.39404H6.63818V10.1763H9.51709V10.9766H6.63818V14.5H5.77344V6.59375H9.74805V7.39404ZM14.5444 8.70459C14.5444 8.23193 14.4048 7.86133 14.1255 7.59277C13.8462 7.32422 13.4756 7.18994 13.0137 7.18994C12.6842 7.18994 12.3548 7.27588 12.0254 7.44775C11.696 7.61605 11.3988 7.8488 11.1338 8.146V7.22217C11.6458 6.71729 12.3083 6.46484 13.1211 6.46484C13.7979 6.46484 14.3421 6.65999 14.7539 7.05029C15.1693 7.44059 15.377 7.96696 15.377 8.62939C15.377 9.19873 15.2445 9.69824 14.9795 10.1279C14.7145 10.554 14.2633 10.9945 13.626 11.4492C13.0244 11.8717 12.6055 12.1922 12.3691 12.4106C12.1364 12.6291 11.9717 12.8368 11.875 13.0337C11.7819 13.2271 11.7354 13.458 11.7354 13.7266H15.5703V14.5H10.8276V14.1133C10.8276 13.68 10.8867 13.3112 11.0049 13.0068C11.1266 12.6989 11.3271 12.3999 11.6064 12.1099C11.8893 11.8162 12.3405 11.4546 12.96 11.0249C13.5257 10.6346 13.9303 10.264 14.1738 9.91309C14.4209 9.55859 14.5444 9.15576 14.5444 8.70459Z"
      fill="#3A3A38"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_486_150)">
      <path
        d="M11.75 13.2598C14.5114 13.2598 16.75 11.0212 16.75 8.25977C16.75 5.49834 14.5114 3.25977 11.75 3.25977C8.98858 3.25977 6.75 5.49834 6.75 8.25977C6.75 11.0212 8.98858 13.2598 11.75 13.2598Z"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M8.21172 11.7891L3.26172 16.7391"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_486_150">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PencilIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.1698 4.50961L15.4798 6.81961L7.31984 14.9896L5.00984 12.6796L13.1698 4.50961ZM13.1698 3.09961L3.58984 12.6796L7.31984 16.4096L16.8998 6.82961L13.1698 3.09961Z"
      fill="#3A3A38"
    />
    <path
      d="M15.0197 3.3098C15.3497 3.3098 15.7097 3.5098 16.0997 3.8998C16.8997 4.6998 16.8797 5.2398 16.1297 6.1298L13.8697 3.8698C14.2497 3.5498 14.6497 3.3098 15.0197 3.3098ZM15.0197 2.3098C13.9797 2.3098 13.1097 3.1798 12.4297 3.8498L16.1497 7.56981C17.1797 6.53981 18.6697 5.0498 16.8097 3.1898C16.1697 2.5498 15.5697 2.2998 15.0197 2.2998V2.3098Z"
      fill="#3A3A38"
    />
    <path
      d="M4.42055 13.4999L5.46055 14.5399L6.50055 15.5799L3.69055 16.2999L4.41055 13.4899M4.70055 12.3699L3.60055 12.6799L2.31055 17.6999L7.33055 16.4099L7.63055 15.2999L6.17055 13.8399L4.70055 12.3699Z"
      fill="#3A3A38"
    />
  </svg>
);

export const PersonIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_83_627)">
      <path
        d="M10 11.1299C12.4853 11.1299 14.5 9.11516 14.5 6.62988C14.5 4.1446 12.4853 2.12988 10 2.12988C7.51472 2.12988 5.5 4.1446 5.5 6.62988C5.5 9.11516 7.51472 11.1299 10 11.1299Z"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
      <path
        d="M3.25 17.8799C3.25 14.1499 6.27 11.1299 10 11.1299C13.73 11.1299 16.75 14.1499 16.75 17.8799"
        stroke="#3A3A38"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_83_627">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlusIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="10" width="11" height="1" fill={fill || "#3A3A38"} />
    <rect
      x="11"
      y="5"
      width="11"
      height="1"
      transform="rotate(90 11 5)"
      fill="#3A3A38"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 12V17H3.5V7" stroke="#3A3A38" strokeMiterlimit="10" />
    <path
      d="M13.69 5.02004V3.04004L17.5 6.98004L13.69 10.92V8.99004C8.22005 8.99004 6.79004 10.68 6.79004 10.68C6.79004 10.68 6.80005 5.02004 13.69 5.02004Z"
      fill="white"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
  </svg>
);

export const TailArrowIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5L17 10L12 15" stroke={fill || "#3A3A38"} />
    <path d="M17 10L4 10" stroke={fill || "#3A3A38"} />
  </svg>
);

export const TimerIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path d="M15 10H10V5" stroke="#3A3A38" strokeMiterlimit="10" />
  </svg>
);

export const TipIcon = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
      stroke="#3A3A38"
      strokeMiterlimit="10"
    />
    <path
      d="M9.28516 12.6094C9.19141 12.3516 9.14453 12.0488 9.14453 11.7012C9.14453 11.459 9.20117 11.2129 9.31445 10.9629C9.43164 10.709 9.72461 10.3555 10.1934 9.90234C10.5879 9.51953 10.8574 9.20898 11.002 8.9707C11.1504 8.72852 11.2246 8.48047 11.2246 8.22656C11.2246 7.85938 11.0918 7.56641 10.8262 7.34766C10.5645 7.12891 10.2246 7.01953 9.80664 7.01953C9.12305 7.01953 8.53906 7.28516 8.05469 7.81641V6.81445C8.67188 6.42773 9.30273 6.23438 9.94727 6.23438C10.5957 6.23438 11.1211 6.4043 11.5234 6.74414C11.9297 7.08398 12.1328 7.54102 12.1328 8.11523C12.1328 8.40039 12.0723 8.6875 11.9512 8.97656C11.8301 9.26172 11.5215 9.64453 11.0254 10.125C10.6113 10.5273 10.3379 10.832 10.2051 11.0391C10.0723 11.2461 10.0059 11.4688 10.0059 11.707C10.0059 11.9727 10.0742 12.2734 10.2109 12.6094H9.28516ZM9.16211 14.4727C9.16211 14.2891 9.22656 14.1348 9.35547 14.0098C9.48438 13.8848 9.63281 13.8223 9.80078 13.8223C9.96875 13.8223 10.1172 13.8848 10.2461 14.0098C10.375 14.1348 10.4395 14.2891 10.4395 14.4727C10.4395 14.6328 10.3789 14.7793 10.2578 14.9121C10.1367 15.041 9.99414 15.1055 9.83008 15.1055C9.63086 15.1055 9.46875 15.041 9.34375 14.9121C9.22266 14.7793 9.16211 14.6328 9.16211 14.4727Z"
      fill={fill || "#3A3A38"}
    />
  </svg>
);

export const TriIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0V12H0L12 0Z" fill="#D9D9D9" />
  </svg>
);
